export default __webpack_public_path__ + "static/media/config-edit.261a2122.png";